import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import { CopyIcon } from './icons';

export const CopyText = ({ text, color }: { text: string; color?: string }) => {
    return (
        <CopyToClipboard
            text={text}
            onCopy={() => toast.success('Text copied to clipboard')}
        >
            <button>
                <CopyIcon color={color} />
            </button>
        </CopyToClipboard>
    );
};
